module.exports = __webpack_public_path__ + "img/sand-decal-11.46c710e8.png";